import { render, staticRenderFns } from "./downAngleSvg.vue?vue&type=template&id=214f2716"
import script from "./downAngleSvg.vue?vue&type=script&lang=js"
export * from "./downAngleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports